goog.provide("shadow.js.shim.module$$mui$material$StepLabel$default");
shadow.js.shim.module$$mui$material$StepLabel$default = shadow.js.shim.module$$mui$material$StepLabel.default;
